import "./graditify_subscription-widget-styles.scss";
import {
  setEventsRadioInputs,
  setModalEvents,
} from "./graditify_subscription-widget-utils";

document.addEventListener("DOMContentLoaded", () => {
  setModalEvents();
});
